import { registerFlow } from '../../../core/flow-register';
import FlowHeader from '../../../components/FlowHeader/FlowHeader';
import FooterSite from '../../../components/FooterSite/FooterSite';
import BaseLayout from '../../../components/BaseLayout/BaseLayout';
import InternalAuthenticator from '../../../components/BaseLayout/InternalAuthenticator';
import SummitRewards from '../../../components/BaseLayout/SummitRewards';
import AddressValidationModal from '../../../components/AddressValidationModal/AddressValidationModal';
import ClosedFundsModal from '../../../components/ClosedFundsModal/ClosedFundsModal';
import CredentialsValidationModal from '../../../components/CredentialsValidationModal/CredentialsValidationModal';
import FONASUMFRolloverScreen from '../../../screens/FONASUMFRolloverScreen/FONASUMFRolloverScreen';
import { FlowNode } from '../../../core/types/flow';
import { contactTextFn, updateFONASUAnalytics } from '../../shared/utils';
import { finish, openModal } from '../../../core/actions';
import {
  usernameValidation,
  isValidFormerEmployer,
  isValidSSN,
  isValidDob,
  meetsMinimumInvestment,
  isUsernameAlreadyTaken,
  isUsernameCreationFailed,
  isTempPasswordCreationFailed,
  chosenClosedFundInFONASU,
  chosenAddressValidation
} from '../../shared/testers';
import { makeLoadRolloverData } from './loaders';
import { createFONASUApplication } from '../shared/loaders';

const nodes: Array<FlowNode> = [
  {
    route: 'fonasuMFRollover',
    screen: FONASUMFRolloverScreen,
    load: makeLoadRolloverData,
    commit: createFONASUApplication,
    form: [
      { name: 'firstName', required: true },
      { name: 'lastName', required: true },
      { name: 'middleName' },
      { name: 'dob', required: true, validation: isValidDob },
      { name: 'citizenship', required: true },
      { name: 'ssn', required: true, validation: isValidSSN },
      { name: 'amount', required: true, validation: meetsMinimumInvestment },
      { name: 'residentialStreet1', required: true },
      { name: 'residentialStreet2' },
      { name: 'residentialZip', required: true },
      { name: 'residentialCity', required: true },
      { name: 'residentialState', required: true },
      { name: 'mailingStreet1', required: true },
      { name: 'mailingStreet2' },
      { name: 'mailingZip', required: true },
      { name: 'mailingCity', required: true },
      { name: 'mailingState', required: true },
      { name: 'primaryEmailAddress', required: true },
      { name: 'phone1' },
      { name: 'phone2' },
      { name: 'phone3' },
      { name: 'mailingAddressDifferent', type: 'checkbox' },
      { name: 'useResidentialAddress', required: true },
      { name: 'useMailingAddress', required: true },
      { name: 'formerEmployer', validation: isValidFormerEmployer },
      { name: 'rolloverType' },
      {
        name: 'username',
        validation: usernameValidation
      },
      {
        name: 'password'
      }
    ],
    next: {
      cases: [
        [chosenAddressValidation, openModal(AddressValidationModal)],
        [isUsernameAlreadyTaken, openModal(CredentialsValidationModal)],
        [chosenClosedFundInFONASU, openModal(ClosedFundsModal)],
        [isTempPasswordCreationFailed, openModal(CredentialsValidationModal)],
        [isUsernameCreationFailed, openModal(CredentialsValidationModal)]
      ],
      default: finish()
    },
    flowProps: {
      analytics: {
        pageName: 'FONASURollover'
      }
    }
  }
];

export default registerFlow({
  namespace: 'front-office/mutual-fund/rollover',
  nodes,
  start: 'fonasuMFRollover',
  pageDecorators: [BaseLayout, InternalAuthenticator, SummitRewards],
  onLoad: updateFONASUAnalytics,
  flowProps: {
    getContactText: contactTextFn(),
    header: FlowHeader,
    footer: FooterSite
  }
});
